export default [
  'Aunt',
  'Child',
  'Cousin',
  'Domestic Partner',
  'Estate',
  'Grandchild',
  'Grandparent',
  'In-law',
  'Nephew',
  'Niece',
  'Parent',
  'Sibling',
  'Spouse',
  'Uncle',
];
